<template>
  <div id="app">
    <a-config-provider :locale="zh_CN">
      <router-view />
    </a-config-provider>
  </div>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');
export default {
  data() {
    return {
      zh_CN
    };
  }
};
</script>

<style>
*,
*:before,
*:after {
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
html {
  font-family: 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 16px;
  word-spacing: 1px;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
}
body {
  height: 100vh;
  background: #fff;
}
img {
  border: 0;
}
ul,
li {
  list-style: none;
}
em,
i {
  font-style: normal;
}
a {
  text-decoration: none;
  color: #282828;
  outline: none;
  -moz-transition: background-color 0.2s ease-out, color 0.1s ease-out;
  -webkit-transition: background-color 0.2s ease-out, color 0.1s ease-out;
  -ms-transition: background-color 0.2s ease-out, color 0.1s ease-out;
  transition: background-color 0.2s ease-out, color 0.1s ease-out;
}
a:hover {
  background-repeat: no-repeat;
  color: #f00;
  text-decoration: none;
}
a,
area {
  blr: expression(this.onFocus=this.blur());
}
/*清除 a 链接在点击时会产生虚线的问题*/
.clearfix:before,
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: ' ';
  clear: both;
  height: 0;
}
.clearfix {
  clear: both;
  *zoom: 1;
}
input,
button,
select,
textarea {
  font-family: 'Microsoft Yahei';
  outline: none;
  border: none;
  border-radius: 0; /*-webkit-appearance: none; -moz-appearance: none;*/
}
.pull-left {
  float: left;
}
.pull-right {
  float: right;
}
.ovh {
  overflow: hidden;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.console-title {
  padding: 15px 0 5px;
  overflow: hidden;
}
.console-title-border {
  border-bottom: 1px solid #f5f5f5;
}
.hover-shadow {
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
}
.hover-shadow:hover {
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1) !important;
}
.pdt30 {
  padding-top: 30px;
}
.vue-html5-editor,
.vue-html5-editor > .toolbar {
  z-index: 99 !important;
}
.select-color .ant-select-tree-node-content-wrapper span {
  color: rgba(0, 0, 0, 1) !important;
}
/*.vue-html5-editor .content img{*/
/*width: 100%!important;*/
/*height: auto;*/
/*}*/
</style>
